import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from '../queries/queryKeys';

const fetchStep = ({ stageId, hideErrorMessage }) => {
  return request.get(
    `/FlatsGrid/step_address_life_cycle_by_stageId/${stageId}`,
    null,
    'Не удалось загрузить этапы помещения',
    'Error',
    undefined,
    undefined,
    undefined,
    hideErrorMessage
  );
};

const useStepLifeQueryByStageId = (params = {}, options) => {
  const { stageId, hideErrorMessage = true } = params;

  return useQuery(
    getQueryKeys.flatStepLife(stageId),
    () => fetchStep({ stageId, hideErrorMessage }),
    { enabled: Boolean(stageId), staleTime: Infinity, ...options }
  );
};

export default useStepLifeQueryByStageId;
